import type { AssetComponentProps } from './AssetsComponent';

export const AssetsComponent = {
    MountAsync: async (target: HTMLElement, props: AssetComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { AssetsComponent } = await import('./AssetsComponent');
        return await mountReactComponentAsync(target, AssetsComponent, props);
    }
};


